import { render, staticRenderFns } from "./goodsValue.vue?vue&type=template&id=76014416&scoped=true&"
import script from "./goodsValue.vue?vue&type=script&lang=js&"
export * from "./goodsValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76014416",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76014416')) {
      api.createRecord('76014416', component.options)
    } else {
      api.reload('76014416', component.options)
    }
    module.hot.accept("./goodsValue.vue?vue&type=template&id=76014416&scoped=true&", function () {
      api.rerender('76014416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/goods/goodsAttribute/goodsValue.vue"
export default component.exports